import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"cartel"> = {
  appId: "cartel",
  cookiePrefix: "cartel",
  lang: "EN",
  artist: {
    name: "Cartel"
  },
  meta: {
    description: "Cartel"
  },
  emailSender: {
    name: "Cartel",
    email: "cartel@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0x84FBe3e127adb3B1eC1eC6DEeeFE17737fb1BF46"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: null,
  socialLinks: [
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UCXwxTXS9s4Trglu9u-9XVew"
    },
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/cartel.band"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/cartel"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/Cartel"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://www.tiktok.com/@cartelband"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.webp`,
          width: 115
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 115
          }
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
